import React from "react";
import { ShopContext } from "../../Context";
import './ProductDetail.css'

export const ProductDetail=()=>{
  const{
    // serviceselected,
    // formatCurrency,
    isProductDetailOpen,
    closeProductDetail,
    productToShow,
    setOpenModal,
    cartProducts,
    setCartProducts
  }=React.useContext(ShopContext)
  const addProductToCart=(event,shopProduct)=>{
    event.stopPropagation();   
    setCartProducts([...cartProducts,shopProduct]);
  }
    return(
       <>
           <aside  className={`${isProductDetailOpen?'product-detail':'hide'}`}>
            <div className="title-product-detail" >
                <h2 >Detalle</h2>
                <div className="button-close-product-detail"
                  onClick={()=>{
                  closeProductDetail();
                  setOpenModal(false)}}>
                    X</div>
            </div>
            <figure >
                <img className="img-product-detail" 
                src={'https://admin.servidev.com/'+productToShow.imagen}
                 alt={productToShow.descripcion} />                 
            </figure>
            <div className="description-product-detail">
            <p> 
                <span >$ {productToShow.precio}</span> 
            </p>
            <p>                     
                <span >{productToShow.descripcion}</span>
            </p>       
                <button onClick={(event)=>{addProductToCart(event,productToShow);
                   }}>
                        Comprar
                </button>
            </div>        
        </aside> 
        
       </>
    )
}